// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUp_container__cE499","loginContainer":"SignUp_loginContainer__16kI4"};